export default "__VITE_ASSET__7c7759e6__"